import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";

// const debug = "CompanySettingsFields"
const debug = false


export const STORY_POINT_DEFAULT_OPTIONS = [
    {value: 1,      label: '1'},
    {value: 2,      label: '2'},
    {value: 3,      label: '3'},
    {value: 5,      label: '5'},
    {value: 8,      label: '8'},
    {value: 13,     label: '13'},
    {value: 21,     label: '21'},
    // {value: 40,     label: '40'},
    // {value: 80,     label: '80'},
    // {value: 100,    label: '100'},
    // {value: 0,      label: '∞'}
];

const fieldsConfig = {

    'storyPoints': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : STORY_POINT_DEFAULT_OPTIONS
    },
    'projectHealthCanHaveNoValue': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },



}

export default class CompanySettingsFields extends ServerSettings {

    public storyPoints                      : any[]
    public projectHealthCanHaveNoValue      : boolean


    constructor(config:any) {

        debug && console.log(debug,'.constructor', config);

        super(config, fieldsConfig);

        this.storyPoints                 = this.initValue('storyPoints')
        this.projectHealthCanHaveNoValue = this.initValue('projectHealthCanHaveNoValue')  // default storage provider for uploads

        debug && console.log(debug,'.constructor - done', this);
    }


    toJSON() {
        const result = {};

        this.valueToJson(result, 'storyPoints')
        this.valueToJson(result, 'projectHealthCanHaveNoValue')

        return result;
    }

}